import { getSlug } from "@huub-web/utils";

import type { NavigationState } from "../../types";
import type { NavigationalPathMap } from "../../contexts";

/**
 * Recursively generates a map of steps (navigation state records) ands their respective paths.
 */
export function getPathMapFromNavigationState(
  navigationState: NavigationState,
  parentKey = "",
  parentPath = "",
): NavigationalPathMap {
  return (navigationState ?? []).reduce((map: NavigationalPathMap, step) => {
    const slug = getSlug(step.slug, ["[", "]"]);

    const currentKey = parentKey ? `${parentKey}.${step.id}` : step.id;
    const currentPath = parentPath ? `${parentPath}/${slug}` : `/${slug}`;

    map[currentKey] = currentPath;

    if (step.steps && step.steps.length > 0) {
      const nestedUrls = getPathMapFromNavigationState(
        step.steps as NavigationState,
        currentKey,
        currentPath,
      );
      Object.assign(map, nestedUrls);
    }

    return map;
  }, {});
}
